import { render, staticRenderFns } from "./myinfo-dob.vue?vue&type=template&id=77c7631e&"
import script from "./myinfo-dob.vue?vue&type=script&lang=js&"
export * from "./myinfo-dob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports